import { render, staticRenderFns } from "./TermOfUseWasserwirtschaft.vue?vue&type=template&id=275902a5&"
import script from "./TermOfUseWasserwirtschaft.vue?vue&type=script&lang=js&"
export * from "./TermOfUseWasserwirtschaft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports